var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import { connect } from "@irati/store";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import walletBadge from "@irati-web/wallet/src/images/wallet_badge.svg";
import { Body, H3 } from "@irati/ui/src/Typography";
import { Image, ImageTextWrapper, GridWrapper, StyledRouterLink } from "./styled/CategoryHeaders";
var SpendCategoryHeader = /** @class */ (function (_super) {
    __extends(SpendCategoryHeader, _super);
    function SpendCategoryHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpendCategoryHeader.prototype.render = function () {
        var _a = this.props, className = _a.className, onButtonClick = _a.onButtonClick, wallet = _a.wallet;
        var availableBalance = wallet.availableBalance, currency = wallet.currency;
        var apps = this.context.apps;
        return (React.createElement(React.Fragment, null,
            React.createElement(GridWrapper, { className: className },
                React.createElement(ImageTextWrapper, null,
                    React.createElement(Image, { src: walletBadge }),
                    React.createElement("div", null,
                        React.createElement(H3, { paddingBottom: 0.5 },
                            React.createElement(FormattedMessage, { id: "perks.categories.spendCategoryHeader.title" })),
                        React.createElement(Body, { small: true, overflow: "hidden" }, availableBalance ? (React.createElement(FormattedMessage, { id: "perks.categories.spendCategoryHeader.hasBalanceSubText", values: { value: React.createElement(FormattedCurrency, { isCents: false, value: availableBalance, currency: currency }) } })) : (React.createElement(FormattedMessage, { id: "perks.categories.spendCategoryHeader.noBalanceSubText" }))))),
                React.createElement(StyledRouterLink, { primary: true, to: "/", app: apps.WALLET, onClick: onButtonClick },
                    React.createElement(FormattedMessage, { id: "perks.categories.spendCategoryHeader.buttonText" })))));
    };
    SpendCategoryHeader.defaultProps = {
        className: null,
        onButtonClick: function () { }
    };
    SpendCategoryHeader.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return SpendCategoryHeader;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({ wallet: wallet });
};
export default connect(mapStateToProps)(SpendCategoryHeader);
